import { createFileRoute } from '@tanstack/react-router';

import { FrontpageEditPage } from '@/components/admin/frontpage-edit-page';
import { useAdminEditPageKey } from '@/hooks/use-admin-navigate';
import { adminHead } from '@/lib/seo';
import {
    adminGetFrontpageFn,
    adminListArticlesByIdsFn,
    adminListArticlesFn,
} from '@/server/functions/admin';

export const Route = createFileRoute('/_admin/admin/frontpage_/$id')({
    component: FrontpageEditRoute,
    head: ({ params }) =>
        adminHead(
            params.id === 'new'
                ? 'בלוק חדש בעמוד הראשי'
                : 'עריכת בלוק בעמוד הראשי',
            `/admin/frontpage/${encodeURIComponent(params.id)}`,
        ),
    staleTime: 0,
    preloadStaleTime: 0,
    loader: async ({ params }) => {
        const row =
            params.id === 'new'
                ? null
                : await adminGetFrontpageFn({ data: { id: params.id } });

        const selectedIds = row?.articleIds ?? [];
        const [selectedArticles, latest] = await Promise.all([
            selectedIds.length
                ? adminListArticlesByIdsFn({ data: { ids: selectedIds } })
                : Promise.resolve([]),
            adminListArticlesFn({
                data: { limit: 15, status: 'published' },
            }),
        ]);

        return {
            row,
            selectedArticles,
            latestArticles: latest.rows,
        };
    },
});

function FrontpageEditRoute() {
    const { row, selectedArticles, latestArticles } = Route.useLoaderData();
    const formKey = useAdminEditPageKey(
        row ? `${row.id}:${String(row.updatedAt)}` : undefined,
    );
    return (
        <FrontpageEditPage
            key={formKey}
            row={row}
            selectedArticles={selectedArticles}
            latestArticles={latestArticles}
        />
    );
}
